import styled from "styled-components";
import { ResponsivePie } from "@nivo/pie";
import { LinkPieChartProps } from "../../../constants/types";
import { COLORS } from "../../../constants/colors";

const LinkPieChart = (props: LinkPieChartProps) => {
  return (
    <Container>
      <ResponsivePie
        data={props.data}
        margin={{ top: 0, right: 20, bottom: 0, left: 20 }}
        activeOuterRadiusOffset={8}
        colors={{ datum: "data.color" }}
        borderWidth={2}
        borderColor={{
          from: "color",
          modifiers: [["darker", 0.2]],
        }}
        theme={{
          text: {
            fontSize: "1.5em",
          },
        }}
        enableArcLinkLabels={false}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor="#333333"
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: "color" }}
        arcLabel="id"
        arcLabelsSkipAngle={10}
        arcLabelsTextColor={{
          from: "color",
          modifiers: [["darker", 2]],
        }}
        tooltip={({ datum: { id, value, color, label, data } }) => (
          <div
            style={{
              padding: 12,
              background: "white",
              border: `2px solid ${color}`,
              boxShadow: " 0 0 10px gray",
            }}
          >
            <span
              style={{
                color: COLORS.fontColor,
                fontSize: "1em",
                fontWeight: 500,
              }}
            >
              {label}
            </span>
            <br />
            <strong style={{ color: COLORS.fontColor, fontSize: "1em" }}>
              총합 : {value} ({value - data.disconnected}/{data.disconnected})
            </strong>
          </div>
        )}
      />
    </Container>
  );
};

export default LinkPieChart;

const Container = styled.div`
  width: 100%;
  height: 50%;
  box-sizing: border-box;
`;
